import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: "app-dialog-anular-trabajo",
    templateUrl: "./dialog-anular-trabajo.component.html",
    styleUrls: ["./dialog-anular-trabajo.component.scss"],
})
export class DialogAnularTrabajoComponent implements OnInit {
    formAnulacion: FormGroup;
    largoMaximo = 500;
    evaluacion: number;
    constructor(
        public dialogRef: MatDialogRef<DialogAnularTrabajoComponent>,
        private fb: FormBuilder
    ) {}

    ngOnInit(): void {
        this.initForm();
    }

    initForm() {
        this.formAnulacion = this.fb.group({
            motivo: [
                "",
                {
                    validators: [
                        Validators.required,
                        Validators.minLength(1),
                        Validators.maxLength(this.largoMaximo),
                    ],
                },
            ],
        });
    }

    get motivo() {
        return this.formAnulacion.get("motivo");
    }

    setEvaluacion(evaluacion: number) {
        this.evaluacion = evaluacion;
    }

    guardar() {
        const data = {
            motivo: this.motivo.value,
            evaluacion: this.evaluacion,
        };
        this.dialogRef.close(data);
    }
}
